<alert id="case-identity-search-results-alert" type="danger" *ngFor="let error of errors">{{error}}</alert>
<div class="table-responsive" id="case-identity-search-result-table-wrapper-div" *ngIf="cases">
  <table id="case-identity-search-results-table"
         class="table full-width table-hover table-condensed table-nowrap">
    <thead id="case-identity-search-results-table-header">
      <tr>
          <th width="22%">
              Party <span popover="Party description" popoverTitle="Party"><i class="fa fa-info-circle"></i></span> 
          </th>
          <th width="20%">
              In Regards To <span popover="In Regards To description" popoverTitle="In Regards To"><i class="fa fa-info-circle"></i></span> 
          </th>
          <th width="11%">
              <span class="field-code">v017.a </span>County<br> 
              <span class="field-code">V003.a </span>Case Number 
              <span [popover]="popTemplateForCounty" popoverTitle="County and Case Number"><i class="fa fa-info-circle"></i></span>
          </th>
          <th width="13%">
            <span class="field-code">V005.f</span>
            Issue <span popover="Issues are specific claims for relief sought by the filing party. For example, Divorce, Money Owed, Default Judgment." 
                      popoverTitle="Issue"><i class="fa fa-info-circle"></i></span>
          </th>
          <th width="13%">
              <span class="field-code">V468 </span>Case Status 
              <span [popover]="popTemplateForStatus" popoverTitle="Case Status"><i class="fa fa-info-circle"></i></span>
          </th>
          <th width="11%">
              <span class="field-code">V473 </span>Judgment Indexed 
              <span popover="A YES in this field indicates there are judgments associated with the case." popoverTitle="Judgment Indexed"><i class="fa fa-info-circle"></i></span> 
            </th>
          <th width="10%">
              Actions <span [popover]="popTemplateForAction" popoverTitle="Actions"><i class="fa fa-info-circle"></i></span> 
          </th>
      </tr>
    </thead>
    <tbody id="case-identity-search-results-table-tbody">
      <tr *ngFor="let case of cases; let i = index;"
          (click)="onViewCaseSelected(case.getCaseIdentifier())"
          [class.highlighted-bgcolor]="(focusedRowNumber === i)">
        <td id ="{{'case-identity-search-results-row-' + i + '-party'}}"
            width="22%"
            title="Click for Case View">
           <div class="table-responsive scroll-hide-xy"> 
             <table class="full-width table-nowrap">
               <tr *ngIf="case.getPartyName()">
                 <td class="text-align-left">
                  <span *ngIf="case.isPartyNameAsAlias()"><span class="field-code">V469.a </span>(Alias) </span>
                  <span class="field-code">V469 </span><span title="{{case.getPartyName()}}">{{case.getPartyName()}}</span>
                 </td>
               </tr>
               <tr *ngIf="case.isPartyNameChanged() && case.getPartyChangedToName()">
                <td class="text-align-left">
                 <span class="field-code">V469 </span><span title="Changed To: {{case.getPartyChangedToName()}}">Changed To: {{case.getPartyChangedToName()}}</span>
                </td>
              </tr>
               <!--<tr *ngIf="case.getPartyNameChangedFromOrTo()"><td class="text-align-left name-subline-color" title="{{case.getPartyNameChangedFromOrTo()}}">{{case.getPartyNameChangedFromOrTo()}}</td></tr>-->
               <tr *ngIf="(case.getPartyAliasCount() === 1)">
                 <td class="text-align-left name-subline-color" title="+{{case.getPartyAliasCount()}} alias"><span class="field-code">V485 </span>+{{case.getPartyAliasCount()}} alias</td></tr>
               <tr *ngIf="(case.getPartyAliasCount() > 1)"><td class="text-align-left name-subline-color" title="+{{case.getPartyAliasCount()}} aliases"><span class="field-code">V485 </span>+{{case.getPartyAliasCount()}} aliases</td></tr>
               <tr *ngIf="(case.getPartyRole()||case.getPartyTitle())">
                 <td class="text-align-left name-subline-color">
                    (<span *ngIf="case.getPartyRole()" title="{{case.getPartyRole()}}"><span class="field-code">V052.w </span>{{case.getPartyRole()}}</span>
                     <span *ngIf="(case.getPartyRole() &&  case.getPartyTitle())"> - </span>
                     <span *ngIf="case.getPartyTitle()" title="{{case.getPartyTitle()}}"><span class="field-code">V107.a </span>{{case.getPartyTitle()}}</span>)
                 </td>
                </tr>
             </table>
           </div>
        </td>
        <td id ="{{'case-identity-search-results-row-' + i + '-in-regards-to'}}"
            width="20%" 
            title="Click for Case View">
            <div class="table-responsive scroll-hide-xy"> 
              <table class="full-width table-nowrap">
                <tr *ngIf="!case.isOtherDataPresent()"><td><i class="fa fa-spinner fa-pulse text-center"></i></td></tr>
                <tr *ngIf="case.getInRegardsTo()"><td class="text-align-left" title="{{case.getInRegardsTo()}}"><span class="field-code">V472 </span>{{case.getInRegardsTo()}}</td></tr>
                <tr *ngIf="(case.getInRegardsToAliasCount() || case.getInRegardsToPartyCount())">
                  <td class="text-align-left name-subline-color">
                     <span *ngIf="(case.getInRegardsToAliasCount() === 1)" title="+{{case.getInRegardsToAliasCount()}} alias"><span class="field-code">V469.b </span>+{{case.getInRegardsToAliasCount()}} alias</span> 
                     <span *ngIf="(case.getInRegardsToAliasCount() > 1)" title="+{{case.getInRegardsToAliasCount()}} aliases"><span class="field-code">V469.b </span>+{{case.getInRegardsToAliasCount()}} aliases</span> 
                     <span *ngIf="((case.getInRegardsToAliasCount() >= 1) && (case.getInRegardsToPartyCount() >= 1))">, &nbsp;</span>
                     <span *ngIf="(case.getInRegardsToPartyCount() === 1)" title="+{{case.getInRegardsToPartyCount()}} party"><span class="field-code">V472.a </span>+{{case.getInRegardsToPartyCount()}} party</span> 
                     <span *ngIf="(case.getInRegardsToPartyCount() > 1)" title="+{{case.getInRegardsToPartyCount()}} parties"><span class="field-code">V472.a </span>+{{case.getInRegardsToPartyCount()}} parties</span> 
                  </td>
                </tr>
                <tr *ngIf="(case.getInRegardsToPartyRole() || case.getInRegardsToPartyTitle())">
                  <td class="text-align-left name-subline-color">
                    (<span *ngIf="case.getInRegardsToPartyRole()" title="{{case.getInRegardsToPartyRole()}}"><span class="field-code">V052.x </span>{{case.getInRegardsToPartyRole()}}</span>
                     <span *ngIf="(case.getInRegardsToPartyRole() &&  case.getInRegardsToPartyTitle())"> - </span>
                     <span *ngIf="case.getInRegardsToPartyTitle()" title="{{case.getInRegardsToPartyTitle()}}"><span class="field-code">V107.b </span>{{case.getInRegardsToPartyTitle()}}</span>)
                  </td>
                </tr>
              </table>
            </div>
        </td>
        <td id ="{{'case-identity-search-results-row-' + i + '-county-case-number'}}"
            width="11%" 
            title="Click for Case View"><span  title="{{case.getCaseCounty() + ' ' + case.getCaseNumber()}}">{{case.getCaseCounty()}}<br>{{case.getCaseNumber()}}</span><br><span *ngIf="case.getTranscriptedToCounty()" title="Transcripted to {{ case.getTranscriptedToCounty()}}">Transcripted to {{ case.getTranscriptedToCounty()}}</span></td>
        <td id ="{{'case-identity-search-results-row-' + i + '-issue'}}"
            width="13%" 
            title="Click for Case View"><span  title="{{case.getIssueDescription()}}">{{case.getIssueDescription()}}</span></td>
        <td id ="{{'case-identity-search-results-row-' + i + '-case-status'}}"
            width="13%" 
            title="Click for Case View"><span *ngIf="case.isOtherDataPresent()" title="{{case.getCaseStatus()}}">{{case.getCaseStatus()}}</span><span *ngIf="!case.isOtherDataPresent()"><i class="fa fa-spinner fa-pulse text-center"></i></span></td>
        <td id ="{{'case-identity-search-results-row-' + i + '-judgment-indexed'}}"
            width="11%" 
            title="Click for Case View"><span title="{{case.getJudgmentDocketedAndIndexed()}}">{{case.getJudgmentDocketedAndIndexed()}}</span></td>
        <td id ="{{'case-identity-search-results-row-' + i + '-actions'}}"
            width="10%"
            (click)="$event.stopPropagation()">
          <a id="{{'case-identity-search-results-row-'+ i + '-action-view-case-lnk'}}" 
             tabindex="{{2000 + i*3 + 1}}"
             title="Click for Case View" 
             (click)="onViewCaseSelected(case.getCaseIdentifier())"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)">
             <span class="glyphicon glyphicon-folder-open"></span><span> View Case</span></a><br>
          <a id="{{'case-identity-search-results-row-'+ i + '-action-add-case-to-cart-lnk'}}" 
             tabindex="{{2000 + i*3 + 2}}"
             title="Click for Adding Case to Cart" 
             (click)="addCaseToCart(case)"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)"
              *ngIf="!isCaseInCart(case.getCaseIdentifier())">
              <span class="glyphicon glyphicon-shopping-cart"></span><span> Add to Cart</span>
          </a>
          <a id="{{'case-identity-search-results-row-'+ i + '-action-remove-case-from-cart-lnk'}}" 
             tabindex="{{2000 + i*3 + 3}}"
             title="Click for Removing Case from Cart" 
             (click)="removeCaseFromCart(case)"
             (focus)="focusedOnRow(i)" (blur)="blurredOffRow(i)"
             *ngIf="isCaseInCart(case.getCaseIdentifier())"  >
             <span class="glyphicon glyphicon-shopping-cart"></span><span > Remove</span>
          </a>
        </td>
      </tr>
     </tbody>
  </table>
</div>
<div *ngIf="requestIsInFlight" class="text-center">
  <i id="civil-search-spinner" class="fa fa-spinner fa-pulse fa-5x text-center"></i>
</div>
<ng-template #popTemplateForCounty>
    <div class="popover-section">The Case County is the county where the case was issued.</div>
    <div class="popover-section">The Case File Number consists of ‘YY&lt;casetype&gt;######’</div>
    <div class="popover-section">where: </div>
    <div class="popover-section">YY – two-digit year when case began (i.e. if a case began in 2005 then YY = 05)</div>
    <div class="popover-section">&lt;casetype&gt; - two or three character code for the type of case (i.e., ‘CVD’ for Civil District, ‘E’ for Estates, ‘CR’ for Criminal, etc.)</div>
    <div class="popover-section">‘######’ - sequence number for case filed.</div>
</ng-template>
<ng-template #popTemplateForStatus>
    <div>Indicates the status of the case.</div>
    <div class="popover-section"><b>NO PENDING ISSUES</b>- All issues on the case have an order result other than PENDING ORDER and there is no appeal on the case.</div>
    <div class="popover-section"><b>PENDING ISSUE(S)</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is no appeal on the case.</div>
    <div class="popover-section"><b>APPEALED</b> - All issues on the case have an order result other than PENDING ORDER but there is an appeal on the case.</div>
    <div class="popover-section"><b>PENDING ISSUE(S)/APPEALED</b> - Any issue on the case has either no order result or an order result of PENDING ORDER and there is an appeal on the case.</div>
</ng-template>
<ng-template #popTemplateForAction>
    <div class="popover-section">Click &lt;View Case&gt; to see the details on the case.</div>
    <div class="popover-section">Click &lt;Add To Cart&gt; to add the case to the cart for printing or emailing.</div>
</ng-template>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-identity-search-results-table/civil-identity-search-results-table.component.html